export default __webpack_public_path__ + "static/bootleg_thumbnail-433bd5bb694725b6c00d27997b728d17.png";